function getReferenceId(reference) {
  if (reference && typeof reference === 'object') return reference.id ?? null;
  return reference ?? null;
}

function getFullName(person) {
  return [person?.name, person?.last_name].map((value) => String(value ?? '').trim()).filter(Boolean).join(' ');
}

export function getCreatorId(task) {
  return getReferenceId(task?.created_by_id ?? task?.created_by ?? task?.createdBy);
}

export function getOwnerId(task) {
  return getReferenceId(task?.owner_id ?? task?.owner);
}

export function isSystemCreator(task) {
  return String(getCreatorId(task) ?? '').toUpperCase() === 'SYSTEM';
}

export function resolvePersonName({ explicitName, people, reference }) {
  const apiName = String(explicitName ?? '').trim();
  if (apiName) return apiName;

  if (reference && typeof reference === 'object') {
    const embeddedName = getFullName(reference);
    if (embeddedName) return embeddedName;
  }

  const id = getReferenceId(reference);
  if (!id) return '';
  if (String(id).toUpperCase() === 'SYSTEM') return 'SYSTEM';

  const person = people.find((candidate) => String(candidate?.id) === String(id));
  return getFullName(person);
}
